import { render } from "./Faq3.vue?vue&type=template&id=53d7313a"
import script from "./Faq3.vue?vue&type=script&lang=js"
export * from "./Faq3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__